import { GetterTree } from 'vuex'
import { GoogleMapPosition, GoogleMapsState, GoogleMapOverlay, GoogleMapMarker, InfoView } from '@/store/modules/google-maps/types'
import { RootState } from '@/store/types'

export const getters: GetterTree<GoogleMapsState, RootState> = {
  groundOverlays: (state: GoogleMapsState): GoogleMapOverlay[] => {
    return state.groundOverlays
  },
  overlayViews: (state: GoogleMapsState): GoogleMapOverlay[] => {
    return state.overlayViews
  },
  position: (state: GoogleMapsState): GoogleMapPosition => {
    return state.position
  },
  zoom: (state: GoogleMapsState): number => {
    return state.zoom
  },
  markers: (state: GoogleMapsState): GoogleMapMarker[] => {
    return state.markers
  },
  activeMarker: (state: GoogleMapsState): GoogleMapMarker => {
    const marker = state.markers.filter(marker => marker.id === state.infoview.status.selectedMarker)
    return marker[0]
  },
  infoView: (state: GoogleMapsState): InfoView => {
    return state.infoview
  },
  autocomplete: (state: GoogleMapsState): { shown: boolean } => {
    return state.autocomplete
  },
  openDefaultMarkerOption: (state: GoogleMapsState): boolean => {
    return state.openDefaultMarkerOption
  },
  defaultMarker: (state: GoogleMapsState): string => {
    return state.defaultMarker
  }
}
